import { updateDocument } from "../../helpers";

export default function setVendor(ref, vendorKey, vendor) {
	return updateDocument(ref, {
		[`vendors.${vendorKey}`]: vendor,
	});
}
